export const GET_FEATURED_PRODUCTS = "GET_FEATURED_PRODUCTS";
export const SET_FEATURED_PRODUCTS = "SET_FEATURED_PRODUCTS";
// export const GET_CATEGORIES = "GET_CATEGORIES";
export const SET_CATEGORIES = "SET_CATEGORIES";
// export const GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES";
export const SET_SUB_CATEGORIES = "SET_SUB_CATEGORIES";

export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";
export const SET_PRODUCT_DETAILS = "SET_PRODUCT_DETAILS";

export const GET_FILTERED_PRODUCTS = "GET_FILTERED_PRODUCTS";
export const SET_FILTERED_PRODUCTS = "SET_FILTERED_PRODUCTS";

export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

export const REGISTER = "REGISTER";
export const REGISTER_PROCEED = "REGISTER_PROCEED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
export const FORGOT_PASSWORD_REQUESTED = 'FORGOT_PASSWORD_REQUESTED';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const GET_PRODUCTS = 'GET_PRODUCTS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const DEL_PRODUCTS = 'DEL_PRODUCTS';



export const GET_PRODUCTS_BIDDING = 'GET_PRODUCTS_BIDDING';
export const SET_PRODUCTS_BIDDING = 'SET_PRODUCTS_BIDDING';

export const GET_PRODUCTS_LISTING = 'GET_PRODUCTS_LISTING';
export const SET_PRODUCTS_LISTING = 'SET_PRODUCTS_LISTING';
export const GET_USER_PRODUCTS_LISTING = 'GET_USER_PRODUCTS_LISTING';
export const UPDATE_SELLER_PRODUCT = 'UPDATE_SELLER_PRODUCT';
export const UPDATE_PRODUCT_DETAIL = 'UPDATE_PRODUCT_DETAIL';

export const ADD_PRODUCT = 'ADD_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';

export const FETCH_PRODUCT = "FETCH_PRODUCT";
export const SET_CAT_DATA = "SET_CAT_DATA";

export const UPDATE_CATEGORIES = "UPDATE_CATEGORIES";
export const UPDATE_SUBCATEGORIES = "UPDATE_SUBCATEGORIES";
export const UPDATE_SUBCATEGORY_FIELDS = "UPDATE_SUBCATEGORY_FIELDS";
export const FETCH_SUBCATEGORY_FIELDS = "FETCH_SUBCATEGORY_FIELDS";
export const FETCH_CATEGORY_FIELDS = "FETCH_CATEGORY_FIELDS";



export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';



export const HIDE_LOADER = "HIDE_LOADER";
export const SHOW_LOADER = "SHOW_LOADER";








// ___________________________________ ADMIN____________________________________

export const SET_REGISTERED_USER = "SET_REGISTERED_USER";
export const GET_REGISTERED_USER_PROCEED = "GET_REGISTERED_USER_PROCEED";
export const DEL_REGISTERED_USER = "DEL_REGISTERED_USER";


export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const EDIT_SUB_CATEGORY = "EDIT_SUB_CATEGORY";
export const DEL_CATEGORY = "DEL_CATEGORY";
export const DEL_SUB_CATEGORY = "DEL_SUB_CATEGORY";


export const ADD_SUB_CATEGORY = "ADD_SUB_CATEGORY";
export const ADD_CATEGORY = "ADD_CATEGORY";

export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";


